import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.back())),
    class: "bg-gray-300 hover:bg-gray-400 text-gray-800 py-1.5 px-4 rounded"
  }, _toDisplayString(_ctx.t('word.back')), 1))
}